/**
 * Which Integrations modal the banner's Reconnect button should open, passed as `?reconnect=`.
 * Null means just open the page: no tier from an older backend, or a free personal number, which
 * has no card of its own.
 */
export const reconnectModalFor = (alert) => {
  if (alert.code !== 'WHATSAPP_DISCONNECTED') return null;
  const tier = alert.meta?.tier;
  if (tier === 'FREE') return alert.scope === 'COMPANY' ? 'free' : null;
  if (tier === 'PAID') return alert.scope === 'PERSONAL' ? 'paid_personal' : 'paid_company';
  return null;
};

export default reconnectModalFor;
